<template>
  <b-card no-body>
    <b-card-body>
      <vue-good-table
        :rows="rows"
        :columns="columns"
        :pagination-options="{ enabled: false }"
      >
        <template slot="emptystate">
          <div class="text-center text-muted py-2">Нет данных по выбранным фильтрам</div>
        </template>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'pack'">
            <div class="font-weight-bold">{{ props.row.name || '—' }}</div>
            <div>
              <b-badge
                v-if="props.row.topic && props.row.topic.name"
                variant="light-primary"
                class="mr-50"
              >
                {{ props.row.topic.name }}
              </b-badge>
              <b-badge
                v-if="props.row.is_archived"
                variant="secondary"
              >
                архив
              </b-badge>
            </div>
            <small>
              <b-link
                v-if="props.row.pack_id"
                :href="planfixPackUrl(props.row.pack_id)"
                target="_blank"
                rel="noopener"
              >
                #{{ props.row.pack_id }}
              </b-link>
            </small>
          </span>
          <span v-else-if="props.column.field === 'premiere_date'">
            {{ formatPremiereDate(props.row.premiere_date) }}
          </span>
          <span v-else-if="props.column.field === 'author'">
            {{ (props.row.author && props.row.author.name) || '—' }}
          </span>
          <span v-else-if="props.column.field === 'games_count'">
            {{ props.row.games_count }}
          </span>
          <span v-else-if="props.column.field === 'revenue'">
            {{ formatRub(props.row.revenue) }}
          </span>
          <span v-else-if="props.column.field === 'author_cost'">
            {{ formatRub(props.row.author_cost) }}
          </span>
          <span
            v-else-if="props.column.field === 'profit'"
            :class="`text-${profitVariant(props.row.profit)}`"
          >
            {{ formatRub(props.row.profit) }}
          </span>
          <span v-else-if="props.column.field === 'roi'">
            <b-badge :variant="roiVariant(props.row.roi)">
              {{ formatRoi(props.row.roi) }}
            </b-badge>
          </span>
          <span v-else-if="props.column.field === 'is_paid_off'">
            <feather-icon
              v-if="props.row.is_paid_off"
              icon="CheckCircleIcon"
              class="text-success"
              size="18"
            />
            <feather-icon
              v-else
              icon="XCircleIcon"
              class="text-danger"
              size="18"
            />
          </span>
          <span v-else>{{ props.formattedRow[props.column.field] }}</span>
        </template>
      </vue-good-table>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BBadge, BLink,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import {
  formatRub, profitVariant, roiVariant, formatRoi, formatPremiereDate, planfixPackUrl,
} from '@/views/finance/utils'

export default {
  components: {
    BCard, BCardBody, BBadge, BLink, VueGoodTable,
  },
  props: {
    rows: { type: Array, default: () => [] },
  },
  setup() {
    const columns = [
      { label: 'Пакет', field: 'pack', sortable: false },
      { label: 'Премьера', field: 'premiere_date', type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'yyyy-MM-dd' },
      { label: 'Автор', field: 'author', sortable: false },
      { label: 'Игр', field: 'games_count', type: 'number' },
      { label: 'Выручка', field: 'revenue', type: 'number' },
      { label: 'Расход', field: 'author_cost', type: 'number' },
      { label: 'Прибыль', field: 'profit', type: 'number' },
      { label: 'ROI', field: 'roi', type: 'number' },
      { label: 'Окупился?', field: 'is_paid_off', type: 'boolean' },
    ]
    return {
      columns,
      formatRub, profitVariant, roiVariant, formatRoi, formatPremiereDate, planfixPackUrl,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
